<template>
  <div>

    



    <b-row class="mt-5">
      <b-col>
        <div class="row">
          <div class="col-md-6 my-auto">
            <h4 class="m-0">Orders List</h4>
          </div>          
        </div>
      </b-col>
    </b-row>

    <div class="card grmt-7 grmb-7" no-body>
      <b-row class="mx-1 mt-3">
        <b-col>
          <div>
            <div id="displayOptions">
              <div class="d-block">
                <div class="d-inline-block float-md-left mr-1 align-top mb-1">
                  <label class="form-group mb-4">
                    <b-form-input
                      type="text"
                      class="form-control data-search-form-control"
                      v-model="search"
                      placeholder="search..."
                    />
                  </label>
                </div>
              </div>

              <div class="float-md-right">
                <b-dropdown
                  id="ddown1"
                  :text="sort.label"
                  variant="light"
                  class="mr-2 d-inline-block float-md-left btn-group"
                  menu-class="bg-white"
                >
                  <b-dropdown-item
                    v-for="(order, index) in sortOptions"
                    :key="index"
                    @click="changeOrderBy(order)"
                  >{{ order.label }}</b-dropdown-item>
                </b-dropdown>

                <b-dropdown
                  id="ddown2"
                  right
                  :text="`${rowsPerPage}`"
                  variant="light"
                  menu-class="bg-white"
                  class="d-inline-block"
                >
                  <b-dropdown-item
                    v-for="(size, index) in pageSizes"
                    :key="index"
                    @click="changePageSize(size)"
                  >{{ size }}</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
          <div style="clear:both;"></div>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <div v-if="isLoad" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>

          <div v-if="!isLoad">
            
            <div class="card bg-light text-black-50 no-border no-shadow no-round">
              <div class="card-body px-3 py-3 font-weight-bold">
                <div class="row no-gutters">  
                  <div class="col-md-2">Order</div>
                  <div class="col-md-3">Created</div>      
                   <div class="col-md-1">Paid</div>
                   <div class="col-md-4">Status</div>                 
                  <div class="col-md-2 text-left text-md-right">Action</div>
                </div>
              </div>
            </div>

            <div v-for="item in items" :key="item.id">
              <div class="border-bottom p-3"  v-bind:class="{ 'bg-warning-light': item.had_failure==1&&item.sent_to_sage==0 , 'bg-white': item.had_failure==0 }">
                <div class="row no-gutters">
                  

                  <div class="col-md-2">
                    <p class="m-0">{{ item.shopify_order_number }}</p>
                  </div>

               

                   <div class="col-md-3">
                     {{ moment(new Date(item.created_at)).format("DDMMMYY HH:mm") }}
                   </div>

                    


                  <div class="col-md-1">
                    <p class="m-0 font-weight-600">
                      <i class="lni lni-checkmark-circle text-success" v-if="item.is_paid==1"></i>
                    </p>
                  </div>

                  <div class="col-md-4">
                    <p class="m-0 font-weight-600">
                      {{item.current_status}}
                    </p>
                  </div>

              

                  <div class="col-md-2 my-auto text-left text-md-right pt-3 pt-md-0">
                    <router-link
                      v-b-tooltip.hover
                      title="view events"
                      :to="{name: 'orders-show',params: { id: item.id }}"
                      class="text-info"
                    >
                      <i class="lni lni-search-alt grmr-7"></i>
                    </router-link>

                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row class="my-3 mx-1">
        <b-col md="6" class="text-center text-md-left" v-if="lastPage > 1">
          <b-pagination
            @change="page  = $event;  getOrders()"
            v-model="page"
            :total-rows="totalRows"
            :per-page="rowsPerPage"
            aria-controls="my-table"
          ></b-pagination>
        </b-col>
        <b-col md="6 text-center text-md-right pt-2">
          <span
            class="text-black-50 font-size-13"
          >Showing {{ fromRow }} to {{ toRow }} of {{ totalRows }}</span>
        </b-col>
      </b-row>
    </div>

   
    

    <b-sidebar 
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'orders' })" 
      :lazy="true" 
      id="sidebar" 
      backdrop shadow>
      <div class="px-3 py-2">
        <router-view></router-view>
      </div>
    </b-sidebar>

  </div>
</template>

<script>
import orderRepo from "@/api/repos/orderRepo";
import { required } from 'vuelidate/lib/validators'


export default {
  components: {
 
  },

  validations: {
    order_number: {
      required,
    },
  },

  data() {
    return {
      errors: [],
      orderFetching: false,
      fetchedOrder: null,
      order_number:null,
      sidebarToggle:false,
      isLoad: false,
      sort: { column: "shopify_order_number", label: "Number Desc", order: "desc" },
      sortOptions: [
        { column: "shopify_order_number", label: "Number Asc", order: "asc" },
        { column: "shopify_order_number", label: "Number Desc", order: "desc" },
        { column: "date_paid", label: "Date Paid Asc", order: "asc" },
        { column: "date_paid", label: "Date Paid Desc", order: "desc" },
    
      ],
      delayTimer: null,
      page: 1,
      rowsPerPage: 10,
      search: "",
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
      pageSizes: [5, 10, 25, 100],
    };
  },
  mounted() {
    this.getOrders();  
  },
  methods: {   
    async getOrders() {
      this.isLoad = true;
      try {
        let { data } = await orderRepo.orders(
          this.page,
          this.rowsPerPage,
          this.sort.column,
          this.sort.order,
          this.search
        );

        this.items = data.orders.data;
        this.totalRows = data.orders.total;
        this.page = data.orders.current_page;
        this.fromRow = data.orders.from;
        this.toRow = data.orders.to;
        this.lastPage = data.orders.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    async handleSubmit () {
      this.fetchedOrder = null
      this.orderFetching = true

      this.$v.$touch()
      if (this.$v.$invalid) {
        this.orderFetching = false
      } else {
        try {
          let data = await orderRepo.fetchShopify(this.order_number);
          this.fetchedOrder = data.data.order          
        } catch (error) {
          console.log(error)             
        } finally{
           this.orderFetching = false 
        }
      }
    },

    async sendToSage(id){      
      this.orderFetching = true
      try {
       let {data}  =  await orderRepo.sendToSage(id);             
       this.fetchedOrder = null;
       setTimeout( () => {
          this.$router.push({name: 'orders-show',params: { id: data.id }}) 
          this.orderFetching = false 
          this.order_number = null; 
        }, 4000); 
               
      } catch (error) {
        console.log(error);
        this.orderFetching = false 
      } 
    },
    
    
    changePageSize(perPage) {
      this.rowsPerPage = perPage;
      this.getOrders();
    },
    changeOrderBy(sort) {
      this.sort = sort;
      this.getOrders();
    },
    searchQuery() {
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(() => {
        this.page = 1;
        this.getOrders();
      }, 750);
    }
  },

  watch: {
    search() {
      this.searchQuery();
    },
    $route: {
      immediate: true,
      handler: function(newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;           
      }
    }
  }
};
</script>
